import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorPage } from '@/components/errors';

const badGatewayErrorSearchSchema = z.object({
  message: z.string().optional(),
  stack: z.string().optional(),
});

export const Route = createFileRoute('/error/502')({
  component: BadGatewayErrorPage,
  validateSearch: badGatewayErrorSearchSchema,
});

function BadGatewayErrorPage() {
  const { message, stack } = Route.useSearch();

  return <ErrorPage status={502} message={message} stack={stack} />;
}
